// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3TB4k","list":"PatternAutocomplete_list__SpW3_"};